import React, { useEffect } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { HowItWorks } from './components/HowItWorks';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-lavender/30" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <WhoIsThisFor data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingOffer data-id="element-9" />
        <SocialProof data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}